<template>
  <div class="container">
    <a-spin class="load" v-show="loading"/>
    <a-affix>
      <div class="section_nav flex-row">
        <img v-if="!isPad" class="thumbnail_nav" @click="goHistory" referrerpolicy="no-referrer"
             src="../../assets/image/a_left.png"/>
        <span class="text_nav">{{ styleName }}</span>
      </div>
    </a-affix>

    <div v-show="!leftShow" class="cursor-pointer" @click="leftShow=true">
      <img class="image_3_1" referrerpolicy="no-referrer" src="../../assets/image/a_unfold.png"/>
    </div>
    <div class="group_5 flex-row justify-between">
      <div v-show="leftShow" class="box_1 flex-col">
        <div class="box_3_2">
          <img class="image_3 cursor-pointer" @click="leftShow=false;" referrerpolicy="no-referrer"
               src="../../assets/image/a_fold.png"/>
        </div>
        <div class="box_2 flex-row justify-between">
          <a-progress type="circle" :percent="taskPercent" :strokeWidth="8" :width="100"
                      strokeColor="rgb(101 216 103)">
            <template #format="percent">
              <span class="text_7_1">{{ percent }}</span>
              <span class="text_8">%</span>
            </template>
          </a-progress>
        </div>
        <div class="text-wrapper_2">
          <span class="text_9">批改进度：</span>
          <span class="text_10">{{ reviseCount }}</span>
          <span class="text_11">/{{ taskAmount }}</span>
        </div>
        <div class="box_5 flex-row">
          <a-input-search placeholder="搜索" style="width: 15.28vw;" @search="onSearch"/>
        </div>
        <a-select v-model='className' class="box_6" @change="changeClass" placeholder="请选择班级">
          <a-select-option :value="item.id" v-for="(item, index) in classData" :key="index">
            {{ item.className }}
          </a-select-option>
        </a-select>
        <div style="overflow-y: auto;overflow-x: hidden;">
          <div :class="(item.isActive ? 'box_8 ' : 'text-wrapper_5')  + 'flex-row cursor-pointer justify-between'"
               v-for="(item,index) in taskList" :key="index" @click="selectTask(item)">
            <div v-if="item.isActive" class="section_3_1 flex-col">
              <span class="text_28">{{ taskType === 'group' ? item.groupName : item.userName }}</span>
            </div>
            <span v-else class="text_20">{{ taskType === 'group' ? item.groupName : item.userName }}</span>
            <span v-if="item.workStatus==0" class="text_21">未提交</span>
            <span v-else-if="item.workStatus==3" class="text_25">已批改</span>
            <span v-else-if="item.workStatus==2" class="text_19">已打回</span>
            <span v-else class="text_14">待批改</span>
          </div>
        </div>
      </div>
      <div class="group_6 flex-col" v-if="!isHasData">
        <img class="img1" width="160px" height="160px" src="../../assets/imgs/nodata.png" alt=""/>
        <span class="text13">暂无数据</span>
      </div>
      <div class="box_9" v-show="isHasData">
        <div :class="(leftShow ? 'box_10 ': 'box_10_e ') + 'flex-col'">
          <div class="text-wrapper_9 flex-row justify-between">
            <span class="text_29">{{ taskOwnName }}的任务</span>
            <span class="text_30">提交时间：{{ commitDate }}</span>
          </div>
          <a-divider/>
          <p class="text_31">
            {{ taskTitle }}
          </p>
          <a-tabs class="task_tabs" type="card" @change="changeActivity" v-model="actKey">
            <a-tab-pane :tab="actTabsNames[idx]" v-for="(item,idx) in activities" :key="item.id">
              <div class="text-group_1" v-html="item.activityContent "></div>
              <div class="group_7">
                <div v-html="item.activityAnswerContent" style="height: 28.533vw; overflow:scroll"></div>
                <a-divider v-if="item.revise.imageList && item.revise.imageList.length>0"/>
                <div class="flex-row">
                  <div class="flex-row ci_div" v-for="(im,idx) in item.revise.imageList" :key="idx">
                    <img class="correctImg" :src="im.path.startsWith('http')?(im.path):(imgUrlHead + '/' +im.path)"
                         alt=""/>
                    <a-icon class="p_icon_close" v-if="item.workStatus==1" type="close" @click="deleteImg(idx)"/>
                  </div>
                </div>
                <div class="flex-row">
                  <div class="flex-row ci_div" v-for="(im,idx) in item.revise.imagePaths" :key="idx">
                    <img class="correctImg" :src="im.startsWith('http')?(im):(imgUrlHead + '/' +im)" alt=""/>
                    <a-icon class="p_icon_close" type="close" @click="deleteImg(idx)"/>
                  </div>
                </div>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div class="box_11 flex-col">
          <div class="group_8 flex-row justify-between">
            <div class="flex-row">
              <div class="image-text_2 flex-row justify-between">
                <span class="text-group_2">作品评价：</span>
              </div>
              <a-rate style="color:@primary-color;" :disabled="!canRevise" v-model="currentActivity.revise.star"
                      :tooltips="desc" @change="starRange"/>
              <a-checkbox @change="goodWork" class="text_35" :disabled="!canRevise"
                          v-model="currentActivity.revise.excellentWorksStatus">推荐为优秀作品
              </a-checkbox>
            </div>
            <a-popover trigger="click" placement="topRight">
              <div class="flex-col" slot="content">
                <div class="group_c">
                  <div class="cursor-pointer hover-gray" v-for="(ic, idx) in comments" :key="idx"
                       @click="selectComment(ic.content)">
                    <span class="text_51_c" :title="ic.content"> {{ ic.content }} </span>
                    <a-divider style="margin:0px;"/>
                  </div>
                </div>
                <a-button v-if="!showSaveComment" @click="showSaveComment=true"
                          style="margin:10px auto 0px auto">
                  <span style="padding: 0.3vw;text-align: center">自定义评语</span>
                </a-button>
                <div v-else class="flex-row align-center" style="margin-top:10px;">
                  <a-input v-model="customComment" placeholder="请输入评语……" :maxLength="50"
                           style="font-size: 1.11vw"></a-input>
                  <a-button style="margin-left:5px;" @click="setComment">
                    <span style="padding: 0.3vw;text-align: center">保存</span>
                  </a-button>
                </div>
              </div>
              <a-button class="text-wrapper_13">
                <span class="text_36">评语模版</span>
              </a-button>
            </a-popover>
          </div>
          <a-textarea class="text-wrapper_14" :disabled="!canRevise"
                      v-model="currentActivity.revise.reviseContent" placeholder="请输入评语"
                      type="textarea" maxlength="100" style="padding: 1vw 1vw 0  1vw;font-size: 1.11vw"
                      :auto-size="{ minRows: 4, maxRows: 4 }"/>
          <div v-if="canRevise" class="group_9 flex-row justify-center">
            <a-button class="text-wrapper_15" @click="redoWork()"><span class="text_38">打回重做</span></a-button>
            <a-button class="text-wrapper_16" @click="commitRevise()">
              <span class="text_39">提交批改</span>
            </a-button>
          </div>
        </div>
      </div>

    </div>
    <a-modal v-model="imgEditorVisible" class="image-modal" title="图片批注" width="70vw" :footer="null">
      <image-editor :in-src="inSrc" @imgUrl="getUrlImg"></image-editor>
    </a-modal>
  </div>
</template>

<script>
import {decryptDes} from 'utils/crypto.js'
import shareState from 'utils/shareState.js'
import ImageEditor from '@/components/ImageEditor.vue'
import format from 'utils/format.js'

export default {
  name: 'PersonHomeWorkDetail',

  props: {
    // 任务类型
    taskType: {
      type: String,
      default: 'person'
    }
  },

  data() {
    return {
      actTabsNames: ['活动一', '活动二', '活动三', '活动四', '活动五'],
      child: true,
      loading: true,
      isPad: true,
      isHasData: false,
      shareState,
      taskOwnName: '', // 当前任务学生名称
      commitDate: null, // 当前任务提交时间
      activities: [], // 任务下活动列表
      currentActivity: {
        revise: {
          id: [],
          star: 0,
          reviseContent: '',
          imageList: [], // 显示批改的图片
          imagePaths: [], // 上传批改的图片
          excellentWorksStatus: false // 是否推荐优秀作品
        }
      }, // 当前焦点活动
      actKey: '',
      classIndex: 0,
      taskId: null, // 任务类型id
      taskName: '', // 任务名称
      taskRecordId: null, // 单条任务主键id
      taskTitle: '', // 任务大标题
      correctImgUrl: '', // 批改后的作业
      replayImg: '', // 教师批改回复的图片地址
      starValue: 0, // 评星
      desc: ['', '', '', '', ''],
      correctAudioList: [], // 批改的语音
      newAudioUrl: '',
      feedBackModal: false, // 反馈弹窗
      teacherId: '', // 当前登录教师id
      userId: '', // 当前任务所属学生id
      token: '',
      audioList: [],
      correctImgList: [], // 批改返回的批改图片集合
      editName: false,
      editPen: true,
      newMess: '',
      isSaveFlag: false,
      oriTaskList: [], // 左侧任务列表原始数据
      taskList: [], // 左侧任务列表
      classData: [], // 左侧班级下拉列表
      className: '', // 当前班级名称
      classId: 0, // 当前班级名称id
      styleId: 0,
      styleName: '', // 任务所属课名称
      leftShow: true,
      customComment: '', // 自定义评语
      comments: [], // 评语列表
      showSaveComment: false, // 展示报错自定义评语按钮
      taskAmount: 0, // 当前批改任务总数
      reviseCount: 0, // 当前已批改任务数（已批改、已打回）
      imgUrlHead: this.$resBasePath, // 图片前缀

      canRevise: true, // 是否可批改
      imgEditorVisible: false,
      inSrc: '' // 图片编辑弹窗传入图片地址
    }
  },
  watch: {
    'currentActivity.revise.reviseContent'(newVal, oldVal) {
      if (newVal.length >= 1) {
        this.isSaveFlag = true
      }
    }
  },
  mounted() {
    this.init()
    this.getClassNum()
    this.getTaskDetail()
    this.getComments()
  },
  methods: {
    init() {
      // console.log(this.$route.params);
      if (this.$route.path.indexOf('/accompanyStudy') === 0) {
        this.isPad = false
        this.canRevise = this.$route.params.workStatus === 1
        this.classId = this.$route.params.classId
        this.styleId = this.$route.params.styleId
        this.styleName = this.$route.params.styleName
        this.taskOwnName = this.taskType === 'group' ? this.$route.params.groupName : this.$route.params.userName
        this.taskId = this.$route.params.taskId
        this.taskName = this.$route.params.taskName
        this.taskRecordId = this.$route.params.taskRecordId
        this.teacherId = this.$getUserInfo().id
        this.userId = this.$route.params.userId
        this.className = this.$route.params.className
        console.log(this.$route.params)
      } else {
        const parameter = decryptDes(this.$route.params.parameter)
        const params = parameter.split('&')
        const obj = JSON.parse(localStorage.getItem('obj'))
        this.canRevise = obj.workStatus === 1
        this.classId = obj.classId
        this.styleId = obj.styleId
        this.styleName = obj.styleName
        this.taskOwnName = this.taskType === 'group' ? obj.groupName : obj.userName
        this.taskId = obj.taskId
        this.taskName = obj.taskName
        this.taskRecordId = obj.taskRecordId
        this.userId = obj.userId
        this.className = obj.className
        this.teacherId = params[1]
        this.token = params[0]
        console.log(obj)
      }
      if (this.taskRecordId == null) {
        this.goHistory()
      }
    },
    obj2Array(obj) {
      const arr = []
      for (var key in obj) {
        if (!obj.hasOwnProperty(key)) {
          continue
        }
        var item = {}
        item[key] = obj[key]
        arr.push(item)
      }
      return arr
    },

    getClassNum() {
      // 班级列表
      const _this = this
      _this
          .$fetch({
            url: _this.$httpConfig.getTeaClassListByUserId,
            body: {
              token: this.token,
              userId: this.teacherId
            }
          })
          .done((res) => {
            if (res && res.success && res.resultCode == 0) {
              _this.classData = res.resultData
              if (_this.classId) {
                // 显示上个页面传递过来classId对应的班级名称
                for (let i = 0; i < _this.classData.length; i++) {
                  if (_this.classId === _this.classData[i].id) {
                    _this.className = _this.classData[i].className
                  }
                }
              } else if (sessionStorage.getItem('className')) {
                _this.className = sessionStorage.getItem('className')
              } else {
                sessionStorage.setItem('className', res.resultData[0].className)
                _this.className = sessionStorage.getItem('className')
              }
              if (this.classId) {
              } else if (sessionStorage.getItem('classId')) {
                _this.classId = sessionStorage.getItem('classId')
              } else {
                sessionStorage.setItem('classId', res.resultData[0].id)
                _this.classId = sessionStorage.getItem('classId')
              }
              _this.getList()
            }
          })
    },

    getList() {
      const param = {
        styleId: this.styleId,
        classId: this.classId,
        taskId: this.taskId
      }
      this.taskList = []
      this.taskAmount = 0
      this.reviseCount = 0
      this.$fetch({
        url:
            this.taskType === 'group'
                ? this.$httpConfig.listClassGroupAndTaskCorrectStatus
                : this.$httpConfig.listClassStudentsAndTaskCorrectStatus,
        body: param
      })
          .loading(
              () => (this.loading = true),
              () => (this.loading = false)
          )
          .done((res) => {
            // console.log(res);
            if (res && res.success && res.resultCode == 0) {
              if (res.resultData && res.resultData.length > 0) {
                res.resultData.forEach((item) => {
                  item.isActive = this.userId === item.userId
                  this.taskList.push(item)
                  // 选择班级，返回后显示暂无数据，刷新当前选中用户任务
                  if (this.userId === item.userId) {
                    this.getTaskDetail()
                  }
                })
                this.taskAmount = res.resultData.length
              }
            }
            this.oriTaskList = this.taskList
            this.reviseCount = this.taskList.filter((o) => o.workStatus === 3).length
          })
    },

    getTaskDetail() {
      this.$fetch({
        url: this.$httpConfig.getStudentTaskActivityDetailsCorrectInfo,
        body: {
          token: this.token,
          taskId: this.taskId,
          classId: this.classId,
          userId: this.userId
        }
      }).done((res) => {
        const _this = this
        if (res && res.success && res.resultCode == 0) {
          if (res.resultData) {
            this.isHasData = true
            _this.activities = res.resultData.activitys
            _this.taskTitle = res.resultData.taskContent
            _this.commitDate = res.resultData.commitDate ? format.formatDayTime(res.resultData.commitDate) : '-'
            if (_this.activities && _this.activities.length > 0) {
              _this.activities.forEach((ac) => {
                if (ac.revise == null) {
                  ac.revise = {
                    id: null,
                    star: 0,
                    reviseContent: '',
                    excellentWorksStatus: '',
                    imageList: [],
                    imagePaths: []
                  }
                } else {
                  if (ac.revise.imageList == null) {
                    ac.revise.imageList = []
                  }
                  if (ac.revise.imagePaths == null) {
                    ac.revise.imagePaths = []
                  }
                }
              })
              _this.currentActivity = _this.activities[0]

              const div = document.createElement('div')
              div.innerHTML = _this.currentActivity.activityAnswerContent
              for (let i = 0; i < div.childNodes.length; i++) {
                const node = div.childNodes[i]
                if (node.nodeName == 'P') {
                  if (node.childNodes && node.childNodes.length > 0) {
                    node.childNodes.forEach((nc) => {
                      if (nc.nodeName == 'IMG') {
                        nc.setAttribute('class', 'img-edit-i')
                      }
                    })
                  }
                }
                if (node.nodeName == 'IMG') {
                  node.setAttribute('class', 'img-edit-i')
                }
              }
              _this.currentActivity.activityAnswerContent = div.innerHTML
              // 从后端返回的优秀作品字段，显示到页面
              _this.currentActivity.revise.excellentWorksStatus = _this.currentActivity.excellentWorksStatus
              _this.actKey = _this.currentActivity.id
              console.log(_this.actKey)
            }
            if (_this.canRevise) {
              _this.$nextTick(() => {
                const imgs = document.getElementsByClassName('img-edit-i')
                for (let i = 0; i < imgs.length; i++) {
                  const img = imgs[i]
                  console.log(img)
                  img.onclick = function () {
                    _this.doImageEdit(img.src)
                    console.log(img.src)
                  }
                }
              })
            }
          }
        }
      })
    },

    starRange(e) {
      // 星星数量设置
      this.starValue = e
      this.isSaveFlag = true
    },
    goodWork(e) {
      // 是否设置为优秀作品
      this.currentActivity.revise.excellentWorksStatuss = e.target.checked
      console.log(`checked = ${e.target.checked}`)
      console.log(`checked = ${e.target.value}`)
      console.log(`checked = ${e}`)
      console.log(`checked = ${this.excellentWorksStatus}`)
    },

    redoWork() {
      // 作业打回重新做
      const param = {
        taskId: this.taskId,
        token: this.token,
        userId: this.userId,
        classId: this.classId
      }
      const _this = this
      _this.$confirm({
        title: '打回重做',
        content: '您确认打回重做吗？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          return new Promise((resolve, reject) => {
            _this
                .$fetch({
                  url: _this.$httpConfig.userTaskReform,
                  body: param
                })
                .done((res) => {
                  resolve(res)
                })
          }).then((res) => {
            if (res && res.success && res.resultCode == 0) {
              _this.$message.success('打回成功')
              _this.isSaveFlag = false
              _this.canRevise = false
              _this.jumpToNext()
            }
          })
        },
        onCancel() {
        }
      })
    },

    doImageEdit(src) {
      // console.log("要编辑的图片地址："+src)
      this.inSrc = src
      this.imgEditorVisible = true
    },
    getUrlImg(data) {
      this.currentActivity.revise.imagePaths.push(data)
      this.imgEditorVisible = false
    },
    deleteImg(idx) {
      this.$delete(this.currentActivity.revise.imagePaths, idx)
    },

    goHistory() {
      this.$router.push({
        name: this.taskType === 'group' ? 'NewGroupWork' : 'NewPersonHomeWork',
        params: {isRevise: this.isRevise}
      })
    },
    changeActivity(key) {
      console.log(key)
      // 如果有视频标签，暂停播放视频
      const videoElements = document.querySelectorAll('video')
      videoElements.forEach(video => {
        video.pause()
      })
      // 切换右侧任务
      const act = this.activities.find((o) => o.id === key)
      const _this = this
      if (act) {
        if (act.revise.imagePaths == null) {
          act.revise.imagePaths = []
        }
        this.currentActivity = act
        const div = document.createElement('div')
        div.innerHTML = act.activityAnswerContent
        for (let i = 0; i < div.childNodes.length; i++) {
          const node = div.childNodes[i]
          if (node.nodeName == 'P') {
            if (node.childNodes && node.childNodes.length > 0) {
              node.childNodes.forEach((nc) => {
                if (nc.nodeName == 'IMG') {
                  nc.setAttribute('class', 'img-edit-i')
                }
              })
              if (node.nodeName == 'IMG') {
                node.setAttribute('class', 'img-edit-i')
              }
            }
          }
        }
        this.currentActivity.activityAnswerContent = div.innerHTML
        _this.currentActivity.revise.excellentWorksStatus = _this.currentActivity.excellentWorksStatus
        if (_this.canRevise) {
          this.$nextTick(() => {
            const imgs = document.getElementsByClassName('img-edit-i')
            for (let i = 0; i < imgs.length; i++) {
              const img = imgs[i]
              img.onclick = function () {
                _this.doImageEdit(img.src)
              }
            }
          })
        }
      }
    },
    changeClass(e) {
      // 切换班级
      this.isHasData = false
      const newData = this.classData.find((item) => item.id === e)
      this.className = newData.className
      sessionStorage.setItem('className', newData.className)
      sessionStorage.setItem('classId', e)
      this.classId = sessionStorage.getItem('classId')
      this.getList()
    },
    onSearch(val) {
      this.taskList =
          this.taskType === 'group'
              ? this.oriTaskList.filter((o) => o.groupName.includes(val))
              : this.oriTaskList.filter((o) => o.userName.includes(val))
    },

    getComments() {
      this.$fetch({
        url: this.$httpConfig.getTeaCorrectReviews,
        body: {
          userId: this.teacherId
        }
      }).done((res) => {
        if (res && res.success && res.resultData) {
          this.comments = res.resultData
        }
      })
    },

    commitRevise() {
      // this.imgEditorVisible = true;
      // 出现问题,完善判断条件
      for (let i = 0; i < this.activities.length; i++) {
        // const reviseContent = this.activities[i].revise.reviseContent.trim()
        const star = this.activities[i].revise.star
        if (typeof star === 'undefined' || star === 0 || star == null) {
          this.$message.error('请完成所有活动星级评价')
          return
        }
        // if (typeof reviseContent === 'undefined' || reviseContent == null || reviseContent === '') {
        //   this.$message.error('请填写所有活动评语')
        //   return
        // }
      }

      const revises = []
      let star = 0
      let content = ''
      this.activities.forEach((o) => {
        const ri = {
          taskId: this.taskId,
          activityId: o.id,
          userTaskActivityAnswerId: o.activityAnswerId,
          content: o.revise ? o.revise.reviseContent : '',
          star: o.revise ? o.revise.star : 0,
          excellentWorksStatus: o.revise.excellentWorksStatus,
          imagePaths: o.revise.imagePaths,
          audioPaths: []
        }
        revises.push(ri)
        star = ri.star
        content = ri.content
        if (star === 0 || content === '') return
      })

      // if (star === 0) {
      //   this.$message.error('请完成所有活动星级评价')
      //   return
      // }
      // if (content === '') {
      //   this.$message.error('请填写所有活动评语')
      //   return
      // }

      const param = {
        token: this.token,
        teacherId: this.teacherId,
        userId: this.userId,
        revises: revises
      }
      console.log(param)

      this.$fetch({
        url: this.$httpConfig.submitTaskCorrect,
        body: param
      }).done((res) => {
        console.log(res)
        if (res && res.success && res.resultData) {
          this.$message.success('提交成功')
          this.canRevise = false
          this.jumpToNext()
        } else {
          this.$message.error('提交失败')
        }
      })
    },
    // 切换学生
    selectTask(item) {
      const _this = this
      if (_this.canRevise) {
        this.$confirm({
          title: '重要提示',
          content: '您可能有未保存的操作，未保存则导致数据丢失，确认不保存吗？',
          okText: '确认',
          cancelText: '取消',
          onOk() {
            _this.refreshTask(item)
          },
          onCancel() {
          }
        })
      } else {
        _this.refreshTask(item)
      }
    },
    // 刷新任务页面
    refreshTask(item) {
      if (item.workStatus === 0 || item.userId === this.userId) return
      this.taskOwnName = item.taskType === 'group' ? item.groupName : item.userName
      this.canRevise = item.workStatus === 1
      this.userId = item.userId
      for (let i = 0; i < this.taskList.length; i++) {
        this.taskList[i].isActive = false
      }
      item.isActive = true
      this.isHasData = true
      this.getTaskDetail()
      console.log('unitActivity-activities', this.activities)
      console.log('unitActivity-currentActivity', this.currentActivity)
    },
    // 跳转下一个待批改的任务
    jumpToNext() {
      this.getList()
      let uId = ''
      let j = -1

      for (let i = 0; i < this.oriTaskList.length; i++) {
        const t = this.oriTaskList[i]
        if (j != -1 && t.workStatus == 1) {
          uId = t.userId
          break
        }
        if (t.userId == this.userId) j = i
      }
      if (uId != '') {
        this.userId = uId
        this.canRevise = true
        this.getTaskDetail()
      }
    },
    selectComment(val) {
      this.currentActivity.revise.reviseContent = val
    },
    setComment () {
      this.showSaveComment = false
      if (!this.customComment === '') {
        this.$fetch({
          url: this.$httpConfig.saveCustomTeaTaskCorrectReviews,
          body: {
            userId: this.teacherId,
            content: this.customComment
          }
        }).done((res) => {
          if (res && res.success && res.resultData) {
            this.customComment = ''
            this.$message.success('保存成功')
            this.getComments()
          } else {
            this.$message.error('保存失败')
          }
        })
      }
    }
  },
  computed: {
    taskPercent() {
      return this.taskAmount === 0 ? 0 : new Number(((this.reviseCount * 100) / this.taskAmount).toFixed(1))
    }
  },

  components: {
    ImageEditor
  },
  beforeRouteLeave(to, from, next) {
    // 判断数据是否修改，如果修改按这个执行，没修改，则直接执行离开此页面
    // this.isneedLeave 防止重复提示
    if (this.isSaveFlag && this.canRevise) {
      this.$confirm({
        title: '重要提示',
        content: '您可能有未保存的操作，未保存则导致数据丢失，确认不保存吗？',
        okText: '确认',
        cancelText: '取消',
        onOk() {
          next()
        },
        onCancel() {
        }
      })
    } else {
      next()
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../assets/homeworkdetail.less';

.ci_div {
  margin-right: 1.042vw;
}

.p_icon_close {
  margin-left: -0.78125vw;
}

.group_6 {
  width: 100%;
  text-align: center;
  margin: auto;
}

.text13 {
  font-size: 1.042vw;
}

.img1 {
  margin: auto;
}
</style>
